import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

interface KioskNonAuthGuardProps {
  children: ReactNode;
}

/**
 * KioskNonAuthGuard — protects public routes (login, consent, etc.)
 * from being accessed by an already-authenticated user.
 *
 * Reads auth state from Redux (kioskAuthSlice), which is only populated after
 * the server-side session verification in kiosk-routes.tsx completes.
 * By the time this guard renders, isAuthChecking is guaranteed to be false,
 * so routing decisions are always based on verified server state.
 */
const KioskNonAuthGuard: FC<KioskNonAuthGuardProps> = ({ children }) => {
  const { isLoggedIn } = useSelector((state: any) => state.kioskAuthSlice);

  // Already authenticated → redirect away from public pages
  if (isLoggedIn) {
    return <Navigate to="/home" replace />;
  }

  // Not authenticated → allow access to the public page
  return <>{children}</>;
};

export default KioskNonAuthGuard;
